module.exports = __webpack_public_path__ + "img/3_88.a5c907ef.png";